/*=========================================================================================
  File Name: module-agreement-mutations.js
  Description: LicenseAgreement Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */

export default {
	updateSystemInfo(state, res) {
		state.SystemInfo = res.Data || [];
	},
	updateTermOfUseResult(state, res) {
		state.TermOfUseResult = res;
	}
};
